import React, { useContext } from 'react';
import GoogleMap from 'google-map-react';
import database from './FireBase.js';
import { getDatabase, ref, onValue, get, set, onDisconnect } from "firebase/database";
import { RecordsManagementContext } from "../StatesMangement/InitialiseContext";
import MapContainer from "../CommonComponents/GoogleMap"
import axios from "axios";
import {UpdateEmpArrivalTime, Elink} from "./Routes";

async function updateArrivalTime(originCoordinates, empLoc, Record, AddressDetails, employee){
    let travelTime
    let db = getDatabase();
    let data = ref(db, `/${AddressDetails.Environment}/Enroute/${employee['employee_id']}`)
    await get(data)
        .then((snapshot) => {
            if (snapshot.exists()) {
                travelTime = snapshot.val().remainingTravelTime;
            } else {
                console.log("No data available for time");
            }
        })
        .catch((error) => {
            console.error("Error fetching location: ", error);
        });
    let formattedHours = Math.floor(travelTime / 3600);
    let formattedMinutes = Math.floor((travelTime % 3600) / 60);
    let formattedSeconds = travelTime
    if(travelTime) {
        if (formattedHours > 0) {
            Record.setTruckArriveTime(`will arrive in ${formattedHours} ${formattedHours > 1 ? 'hours' : 'hour'} ${formattedMinutes} ${formattedMinutes > 1 ? 'minutes' : 'minute'}`)
        } else if (formattedHours == 0 && formattedMinutes > 0) {
            Record.setTruckArriveTime(`will arrive in ${formattedMinutes} ${formattedMinutes > 1 ? 'minutes' : 'minute'}`)
        } else if (formattedHours == 0 && formattedMinutes == 0) {
            Record.setTruckArriveTime(`will arrive in ${formattedSeconds} ${formattedSeconds >= 10 ? 'seconds' : 'second'}`)
        }
        if (formattedMinutes <= 1) {
            if (!Record.hideArrivedMessage && !Record.OriginReached) {
                axios({
                    method: 'post',
                    url: UpdateEmpArrivalTime,
                    params: {estimate_key: Elink, employee_key: document.cookie.split('employee_id=')[1]}
                })
            }
            setTimeout(() => {
                Record.setOriginReached(true)
                setTimeout(() => {
                    Record.sethideArrivedMessage(true);
                    setMapPosition(document.getElementById('map-container-div'));
                }, 60000); // 60000ms = 1 minute
            }, 45000); // 45000 = 45 seconds
        }else{
            setMapPosition(document.getElementById('map-container-div'));
        }
    }
}

function setMapPosition(el){
    if (el) {
        let currentPos = el.getBoundingClientRect()
        for (var lx = 0, ly = 0;
             el != null;
             lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
        let pos = { x: lx, y: ly, height: currentPos.height, width: currentPos.width }
        document.getElementById('map_canvas').style.cssText = `position:absolute;top:${pos.y}px;left:${pos.x}px;height:${pos.height}px; width:${pos.width}px;overflow:hidden`
    }
}

const SimpleMap = (props) => {
    const removeScript = () =>{ // To remove already added google maps script on index page as it renders again through GoogleMap component. 
        let scriptRef= document.getElementById('_d1')
        scriptRef.parentNode.removeChild( scriptRef );
    }
    const toggleShowMap = () => {
        Record.setShowMap(true)
        removeScript()
    };
    let Record = useContext(RecordsManagementContext)
    const center = {
        lat: 0,
        lng: 0
    };
     const renderMarkers = async (map, maps, hash) => {
        let empLoc
        let portalOpened
        let CP_PageDetails = Record.CP_PageDetails
        let AddressDetails = CP_PageDetails.AddressLatLng // origin and destination coordinates.
        let ExtraStops = CP_PageDetails.ExtraStopAddress // get extra stops.
        const EmployeeDetails = CP_PageDetails.EmployeeData // Employees records.
        const travelEmployee = CP_PageDetails.enrouteData // travel Employees records.
        const originCoordinates = CP_PageDetails.originCoordinates // origin coordinates.
        let OfficeAddress = CP_PageDetails.AddressLatLng.OfficeAddress //office address of the company.
        let db
        let EmployeesMarkersHash = {}
        let OriginLat = 0, OriginLng = 0
        let Destination = AddressDetails.Destination
        let Origin = AddressDetails.Origin
        let extraStopHash = []
        let icon
        if (EmployeeDetails !== undefined) {
            db = getDatabase();
            icon = {
                url: `${process.env.PUBLIC_URL + "Images/truckMarkerBrighter.gif"}`,
                scaledSize: new window.google.maps.Size(35, 35), // size
            };
            EmployeeDetails.map(async (employee) => {
                portalOpened = ref(db, `/${AddressDetails.Environment}/ClientPortalOpened/${originCoordinates.estimate_id}`)
                set(portalOpened, true)
                onDisconnect(portalOpened).set(false)
                let locationToken
                let EmployeeMarker
                // fetch live data of an employee from firebase database
                let data = ref(db, `/${AddressDetails.Environment}/EmployeeLocation/${employee['employee_id']}`)

                onValue(data, snapshot => {
                    let location = snapshot.val(); //fetch live location of an employee
                    empLoc = location
                    if (location !== null && EmployeesMarkersHash[employee['employee_id']] === undefined) {//This will execute when employee's start their live location
                        locationToken = location.locationToken
                        EmployeeMarker = new window.google.maps.Marker({//show truck live location(through marker on the map)
                            icon: icon,
                            position: { lat: location.latitude, lng: location.longitude },
                            title: `Name :-  ${employee.employee_name}` + "  " +
                                `Phone Number :-  ${employee.phone_number}`,
                            map,

                        });
                        if(travelEmployee && travelEmployee['employee_id'] == employee['employee_id'] && !Record.OriginReached && travelEmployee['arrived_at'] == null) {
                            updateArrivalTime(originCoordinates, empLoc, Record, AddressDetails, employee)
                            setMapPosition(document.getElementById('map-container-div'))
                        }
                        EmployeesMarkersHash[employee['employee_id']] = EmployeeMarker
                        return EmployeeMarker;
                    }
                    else if (location !== null && EmployeesMarkersHash[employee['employee_id']] !== undefined) {//this will execute when there is any update in the location of employee
                        let mark = EmployeesMarkersHash[employee['employee_id']];
                        let latLng = { lat: location.latitude, lng: location.longitude }
                        mark.setPosition(latLng)
                        if(travelEmployee && travelEmployee['employee_id'] == employee['employee_id'] && !Record.OriginReached && travelEmployee['arrived_at'] == null) {
                            updateArrivalTime(originCoordinates, empLoc, Record, AddressDetails, employee)
                            setMapPosition(document.getElementById('map-container-div'))
                        }
                    }
                })
            })
        }

        if (OfficeAddress) {
            extraStopHash.push({
                location: Origin,
                stopover: true
            })
            if (ExtraStops) {
                ExtraStops.map((extra_stop, i) => {
                    extraStopHash.push({
                        location: extra_stop["Address"],
                        stopover: true
                    })
                })
            }
            extraStopHash.push({
                location: Destination,
                stopover: true
            })
        }
        else {
            if (ExtraStops) {
                ExtraStops.map((extra_stop, i) => {
                    extraStopHash.push({
                        location: extra_stop["Address"],
                        stopover: true
                    })
                })
            }
        }

        const directionsService = new window.google.maps.DirectionsService();
        const directionsRenderer = new window.google.maps.DirectionsRenderer();
        directionsRenderer.setMap(map);
        const origin = Origin;
        const destination = Destination;
        directionsService.route(
            {
                origin: OfficeAddress ? OfficeAddress : origin,
                destination: OfficeAddress ? OfficeAddress : destination,
                waypoints: extraStopHash,
                travelMode: window.google.maps.TravelMode.DRIVING

            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    directionsRenderer.setDirections(result);
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            }
        );
        center.lat = OriginLat
        center.lng = OriginLng
    };

    return (
        <div style={{ height: '300px', width: '100%' }} id="map_canvas">
            {
                Record.showMap ?
                    <GoogleMap
                        bootstrapURLKeys={{ key: Record.CP_PageDetails.MapKey[0] }}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
                        zoom={8}
                        center={center}
                    >
                    </GoogleMap>
                    :
                    <div style={{position:'relative'}}>
                        <img src={process.env.PUBLIC_URL + "/Images/blurredimage.png"}
                            style={{ width: "100%", height: "100%" }} />
                        <button className="centeredButton btn-right bg-cl" onClick={toggleShowMap}>Click Here to View Map</button>
                    </div>}
        </div>
    );
}

export default React.memo(SimpleMap);








